import { RoutesApp } from '@constants/routes'
import { UserType } from '@customTypes/user'
import {
  IconAddressBook,
  IconBoxMultiple,
  IconBuildingWarehouse,
  IconCube,
  IconDashboard,
  IconDatabaseExport,
  IconFileDescription,
  IconForklift,
  IconHome,
  IconMapPinPlus,
  IconReceipt,
  IconShoppingCart,
  IconTools,
} from '@tabler/icons-react'

type NavBarItem = {
  label: string
  icon: React.ReactNode
  check: (user: UserType) => boolean
  path: string
}

const navBarItems: NavBarItem[] = [
  { label: 'Inicio', path: RoutesApp.HOME, icon: <IconHome />, check: () => true },
  { label: 'Dashboard', path: RoutesApp.DASHBOARD, icon: <IconDashboard />, check: () => true },
  { label: 'Clientes', path: RoutesApp.CLIENTS, icon: <IconAddressBook />, check: () => true },
  {
    label: 'Exportar',
    path: RoutesApp.EXPORT,
    icon: <IconDatabaseExport />,
    check: (user: UserType) => user?.role === 'admin',
  },

  {
    label: 'Geo Checkpoints',
    path: RoutesApp.GEO_CHECKPOINTS,
    icon: <IconMapPinPlus />,
    check: (user: UserType) => user?.role === 'admin',
  },
  {
    label: 'Proformas',
    path: RoutesApp.PROFORMAS,
    icon: <IconFileDescription />,
    check: () => true,
  },
  {
    label: 'Ordenes de compra',
    path: RoutesApp.ORDER_PURCHASES,
    icon: <IconShoppingCart />,
    check: () => true,
  },
  { label: 'Bloques', path: RoutesApp.BLOCK, icon: <IconBoxMultiple />, check: () => true },
  { label: 'Recetas', path: RoutesApp.RECEIPTS, icon: <IconReceipt />, check: () => true },
  { label: 'Materias prima', path: RoutesApp.RAW_MATERIALS, icon: <IconCube />, check: () => true },
  {
    label: 'Bodega de materiales',
    path: RoutesApp.WAREHOUSE,
    icon: <IconBuildingWarehouse />,
    check: () => true,
  },
  { label: 'Herramientas', path: RoutesApp.TOOLS, icon: <IconTools />, check: () => true },
  {
    label: 'Bodega de herramientas',
    path: RoutesApp.WAREHOUSE_TOOLS,
    icon: <IconForklift />,
    check: () => true,
  },
]

export function buildItemsNavBar(user: UserType | null): NavBarItem[] {
  if (!user) return []

  return navBarItems.filter((item) => item.check(user))
}
